import { Component, OnInit } from '@angular/core';
import * as Parallax from 'parallax-js';
import { trigger, style, transition, animate, keyframes } from '@angular/animations';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
  animations: [
    trigger('animation', [
      transition('normal => move', [
        animate(800, keyframes([
          // style({ opacity: 1, transform: 'scale(1)', offset: 0 }),
          // style({ opacity: 0.6, transform: 'scale(0.5) translateZ(-1000em)', offset: 0.2 }),
          // style({ opacity: 0.3, offset: 0.89 }),
          // style({ opacity: 0, transform: 'scale(0.5) translateZ(-1000em)', offset: 1.0 })
          style({ opacity: 0, transform: 'scale3d(0.3, 0.3, 0.3)' }),
          style({ opacity: 0.2, transform: 'scale3d(0.5, 0.5, 0.5)' }),
          style({ opacity: 0.5, transform: 'scale3d(0.9, 0.9, 0.9)' }),
          style({ opacity: 1, transform: 'scale3d(1, 1, 1)' })
        ]))
      ]),
      transition('move => normal', [
        animate(500, keyframes([
          // style({ opacity: 0, transform: 'scale(0.5) translateZ(-1000em)', offset: 0 }),
          // style({ opacity: 0.3, offset: 0.2 }),
          // style({ opacity: 0.6, transform: 'scale(1)', offset: 0.89 }),
          // style({ opacity: 1, offset: 1.0 })
          style({ opacity: 1 }),
          style({ opacity: 0.5, transform: 'scale3d(0.9, 0.9, 0.9)' }),
          style({ opacity: 0.2, transform: 'scale3d(0.5, 0.5, 0.5)' }),
          style({ opacity: 0, transform: 'scale3d(0.3, 0.3, 0.3)' }),
          style({ opacity: 0 })
        ]))
      ])
    ]),

    trigger('animation2', [
      transition('normal => move', [
        animate(800, keyframes([
          // style({ opacity: 1, transform: 'scale(1)', offset: 0 }),
          // style({ opacity: 0.6, transform: 'scale(0.5) translateZ(-1000em)', offset: 0.2 }),
          // style({ opacity: 0.3, offset: 0.89 }),
          // style({ opacity: 0, transform: 'scale(0.5) translateZ(-1000em)', offset: 1.0 })
          style({ opacity: 0, transform: 'scale3d(0.3, 0.3, 0.3)' }),
          style({ opacity: 0.2, transform: 'scale3d(0.5, 0.5, 0.5)' }),
          style({ opacity: 0.5, transform: 'scale3d(0.9, 0.9, 0.9)' }),
          style({ opacity: 1, transform: 'scale3d(1, 1, 1)' })
        ]))
      ]),
      transition('move => normal', [
        animate(500, keyframes([
          // style({ opacity: 0, transform: 'scale(0.5) translateZ(-1000em)', offset: 0 }),
          // style({ opacity: 0.3, offset: 0.2 }),
          // style({ opacity: 0.6, transform: 'scale(1)', offset: 0.89 }),
          // style({ opacity: 1, offset: 1.0 })
          style({ opacity: 1 }),
          style({ opacity: 0.5, transform: 'scale3d(0.9, 0.9, 0.9)' }),
          style({ opacity: 0.2, transform: 'scale3d(0.5, 0.5, 0.5)' }),
          style({ opacity: 0, transform: 'scale3d(0.3, 0.3, 0.3)' }),
          style({ opacity: 0 })
        ]))
      ])
    ]),

    trigger('animation3', [
      transition('normal => move', [
        animate(800, keyframes([
          // style({ opacity: 1, transform: 'scale(1)', offset: 0 }),
          // style({ opacity: 0.6, transform: 'scale(0.5) translateZ(-1000em)', offset: 0.2 }),
          // style({ opacity: 0.3, offset: 0.89 }),
          // style({ opacity: 0, transform: 'scale(0.5) translateZ(-1000em)', offset: 1.0 })
          style({ opacity: 0, transform: 'scale3d(0.3, 0.3, 0.3)' }),
          style({ opacity: 0.2, transform: 'scale3d(0.5, 0.5, 0.5)' }),
          style({ opacity: 0.5, transform: 'scale3d(0.9, 0.9, 0.9)' }),
          style({ opacity: 1, transform: 'scale3d(1, 1, 1)' })
        ]))
      ]),
      transition('move => normal', [
        animate(500, keyframes([
          // style({ opacity: 0, transform: 'scale(0.5) translateZ(-1000em)', offset: 0 }),
          // style({ opacity: 0.3, offset: 0.2 }),
          // style({ opacity: 0.6, transform: 'scale(1)', offset: 0.89 }),
          // style({ opacity: 1, offset: 1.0 })
          style({ opacity: 1 }),
          style({ opacity: 0.5, transform: 'scale3d(0.9, 0.9, 0.9)' }),
          style({ opacity: 0.2, transform: 'scale3d(0.5, 0.5, 0.5)' }),
          style({ opacity: 0, transform: 'scale3d(0.3, 0.3, 0.3)' }),
          style({ opacity: 0 })
        ]))
      ])
    ])
  ]
})
export class HomeComponent implements OnInit {

  constructor() { }

  state: string = 'normal';

  onAnimateIn() {
    this.state = 'normal';
  }

  onAminate() {
    this.state = 'move';
    var scene = document.getElementById('scene');
    var parallax = new Parallax(scene, {
      relativeInput: true,
    });
  }

  transitionend = (): void => {
    var elm = document.getElementById("swiper-wrapper");
    if (elm != null) {
      var rec = elm.getBoundingClientRect();
      // var innerWidth: number = window.innerWidth;

      var first = document.getElementById('first');
      var firstLast = document.getElementById('firstToLast');
      var last = document.getElementById('lastPg');
      var secondLast = document.getElementById('secondToLast');
      var atmospheric = document.getElementById('atmospheric');

      // console.log('rec.left-> ', rec.left);
      // console.log('innerWidth-> ', innerWidth);
      // console.log((innerWidth/5)*4);

      if (Math.abs(rec.left) == 0) {
        // this.onAnimateOut();
        // last.style.opacity = '0';
        // secondLast.style.opacity = '0';
        // atmospheric.style.opacity = '0';

        this.onAminate();
        first.style.opacity = 'initial';
        firstLast.style.opacity = 'initial';
        last.style.opacity = 'initial';
        secondLast.style.opacity = 'initial';
        atmospheric.style.opacity = 'initial';
      }
      else if (Math.abs(rec.left) != 0) {
        this.onAnimateIn();
        first.style.opacity = '0';
        firstLast.style.opacity = '0';
        last.style.opacity = '0';
        secondLast.style.opacity = '0';
        atmospheric.style.opacity = '0';
        //   last.style.opacity = 'initial';
        //   secondLast.style.opacity = 'initial';
        //   atmospheric.style.opacity = 'initial';
      }
    }
  }

  parallax() {
    var scene = document.getElementById('scene');
    var parallax = new Parallax(scene, {
      relativeInput: true,
    });
  }

  initial: boolean = true;
  entry() {
    this.initial = false;
  }

  ngOnInit() {
    var elm = document.getElementById("navbar");
    elm.removeAttribute("background");

    this.entry();
    this.parallax();
    window.addEventListener('transitionend', this.transitionend, true);
  }

}



// WEBPACK FOOTER //
// ./src/app/home/home.component.ts